import { subscribe, unSubscribe } from "@/api/decorate";
import { platform } from "@/utils/platform";
import useNavigation from "@/utils/useNavigate";
import AKJS from "@akc/akjs";
import { Switch, Toast } from "antd-mobile";
import React, { useEffect, useRef, useState } from "react";
import styles from "./ActiveSignList.module.less";
import PopForSign from "./PopForSign";
import SignCalendar from "./SignCalendar";
import SignCard from "./SignCard";

const SignList: React.FC<{ activityInfo: any; handleSignIn: any }> = ({
  activityInfo,
  handleSignIn,
}) => {
  const [calendarVisible, setCalendarVisible] = useState(false);
  const [enableRemind, setEnableRemind] = useState(false);
  const [popForSignVisible, setPopForSignVisible] = useState(false);
  const popstateCallback = useRef<any>(null);

  const { navigate } = useNavigation();

  const subscribeMessage = () => {
    // if (platform.isSaas) {
    //   return;
    // }
    setEnableRemind(true);
    if (platform.isApp && !enableRemind) {
      // app推送消息
      AKJS.ready().then(() => {
        AKJS.action
          .dispatch("natPermissions", {
            type: "notification",
          })
          .then(res => {
            console.log(11111, res.data.granted);
            if (res.data.granted) {
              // 订阅消息
              subscribe({
                bizType: "DAILY_AWARD",
                bizNo: activityInfo.promoActivityId,
              })
                .then(() => {
                  Toast.show("订阅成功");
                })
                .catch(err => {
                  Toast.show("订阅失败");
                  setEnableRemind(false);
                });
            }
          });
      });
    } else if (platform.isMini && !enableRemind) {
      // 跳到小程序订阅页面
      let tempKey = "daily_reward";
      window.wx.miniProgram.navigateTo({
        url: `/order/pages/subscribe-message/subscribe-message?tempKey=${tempKey}&bizType=DAILY_AWARD&bizNo=${activityInfo.promoActivityId}&modalContent=日日奖签到订阅&tempName=签到提醒&bgImg=https://akim-oss.aikucun.com/902ba3cda1883801594b6e1b452790cc53948fda_1725591882855_32.png`,
      });
    }
  };

  const unSubscribeMessage = () => {
    setEnableRemind(false);
    // 取消订阅
    unSubscribe({
      bizType: "DAILY_AWARD",
      bizNo: activityInfo.promoActivityId,
    })
      .then(() => {
        Toast.show("已取消订阅");
      })
      .catch(err => {
        setEnableRemind(true);
      });
  };

  const toMyReward = () => {
    const currentTime = new Date().getTime()?.toString();
    const query = {
      promoActivityId: activityInfo?.promoActivityId,
      timestamp: currentTime,
    };
    navigate({
      h5Options: {
        url: "/mx-shop-micro/reward",
        query: query,
      },
      appOptions: {
        url: `${origin}/mx-shop-micro/reward?promoActivityId=${activityInfo?.promoActivityId}&timestamp=${currentTime}`,
      },
      miniOptions: {
        url: `${origin}/mx-shop-micro/reward`,
        query: query,
      },
    });
  };

  const onClickSignIn = async () => {
    if (activityInfo.lotteryInfo?.btnStatus !== 2) {
      return;
    }
    await handleSignIn();
    setPopForSignVisible(false);
    setTimeout(() => {
      if (platform.isMini) {
        subscribeMessage();
      } else if (platform.isApp) {
        subscribeMessage();
      }
    }, 1000);
  };

  useEffect(() => {
    setTimeout(() => {
      document.querySelector(".todaySignCard")?.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }, 1000);
    if (activityInfo.lotteryInfo?.btnStatus === 2) {
      setPopForSignVisible(true);
    }
    setEnableRemind(activityInfo.enableRemind);
  }, [activityInfo]);

  useEffect(() => {
    if (platform.isMini) {
      popstateCallback.current = () => {
        if (window.location.hash) {
          const hash = location.hash.split("#")[1];
          if (hash === "subscribeTrue") {
            setTimeout(() => {
              setEnableRemind(true);
            }, 500);
          } else if (hash === "subscribeFalse") {
            setTimeout(() => {
              setEnableRemind(false);
            }, 500);
          }
        }
      };
      window.addEventListener("popstate", popstateCallback.current);
    }
    return () => {
      popstateCallback.current && window.removeEventListener("popstate", popstateCallback.current);
    };
  }, []);

  return (
    <div className={styles.wrap}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <span className={styles.headerLeftTitle}></span>
        </div>
        <div className={styles.headerRight} onClick={() => setCalendarVisible(true)}>
          <img src="https://akim-oss.aikucun.com/0bc8890a37772bf6de660932fe9911337711670a_1740030225467_72.png" alt="" />
          <span>签到日历</span>
        </div>
      </div>
      <div className={styles.main}>
        <div className={styles.list}>
          {activityInfo.signInTaskInfo?.signInItemList.map((item, index) => (
            <SignCard key={index} info={item} />
          ))}
        </div>
      </div>
      <div className={styles.bottom}>
        <div className={styles.bottomLeft} onClick={toMyReward}>
          <img src="https://akim-oss.aikucun.com/ba8e0d12b9162b518a715061a4bc22faa3afae6d_1740030835943_75.png" alt="" />
          <span>我的奖励</span>
        </div>
        {!platform.isH5 && (
          <div className={styles.noticeMessages}>
            <span className={styles.remind}>提醒我</span>
            <Switch
              checked={enableRemind}
              disabled={activityInfo.status !== "BEGIN"}
              style={{ "--width": "32px", "--height": "18px" }}
              onChange={isOpen => (isOpen ? subscribeMessage() : unSubscribeMessage())}
              className={styles.switch}
            />
          </div>
        )}
      </div>
      <SignCalendar
        visible={calendarVisible}
        setVisible={setCalendarVisible}
        promoActivityId={activityInfo.promoActivityId}
        limitStartTime={activityInfo.startTime}
        limitEndTime={activityInfo.endTime}
        activityInfo={activityInfo}
      />
      {/* <PopForSign
        visible={popForSignVisible}
        setVisible={setPopForSignVisible}
        handleSignIn={onClickSignIn}
      /> */}
    </div>
  );
};

export default SignList;
